import { USBColumn, USBGrid } from "@usb-shield/react-grid/dist/esm";
import classNames from "classnames";
import { CommonLayoutProps } from "../lib.ts";
import PropTypes from "prop-types";
import React from "react";
import ShellGridColumn from "./shellGridColumn";

const BlockLayout = ({
  children,
  compact,
  showMobileBackground,
  contentDirection,
  removeBottomSpace,
  id,
  removeInMobileBP,
  actAs,
  removeSpaceOf,
  showThinBottomMargin,
  showBottomDivider,
  isOnlyCardChild,
  mobileTopMargin,
  mobileBottomMargin,
  desktopTopLeftMargin,
  contentOnTop,
  cardColorTheme,
  contentTopTheme,
  gapOnTop,
  gapOnBottom,
  isCardWithChildren,
  isMultiColumn,
  isMultiGrid,
  isCardListChild,
  hasGridZeroPadding,
  hasTopContentGridZeroPadding,
  mobileZeroBottomMarginFirstChild,
  removeOlbTopPadding,
  gapThruMarginOnly,
  cardInternalPadding,
  gapThruMarginTop,
  ...otherProps
}: CommonLayoutProps) => {
  const actAsNone = actAs === "None";
  const actAsPageHeader = actAs === "PageHeader";
  const actAsPageFooter = actAs === "PageFooter";
  const actAsCardFirstChildd = actAs === "CardFirstChild";
  const actAsCardLastChild = actAs === "CardLastChild";
  const actAsCardLastChildFooter = actAs === "CardLastChildFooter";
  const actAsCardMiddleChild = actAs === "CardMiddleChild";
  const actAsCardChild = actAs === "CardChild";
  const actAsShell = actAs === "Shell";
  const actAsShellChild = actAs === "ShellChild";
  const actAsSrOnly = actAs === "SrOnly";
  const actAsGhost = actAs === "Ghost";
  if (actAsGhost) {
    return <></>;
  }
  if (actAsSrOnly) {
    return <>{children}</>;
  }

  return (
    <>
      {contentOnTop && (
        <USBGrid
          gridGap="normal"
          padding={hasTopContentGridZeroPadding ? "zero" : "normal"}
          addClasses={classNames(
            ...[
              "usbobp-layout--override-row-gap",
              "usbobp-layout--override-tb-padding",
              {
                "usbobp-layout--content-top-theme-white":
                  contentTopTheme === "white",
              },
            ]
          )}
          addContainerClasses={classNames("usbobp-layout--content-on-top", {
            "usbobp-layout--gap-on-top-0": contentOnTop && gapOnTop === "0",
            "usbobp-layout--gap-on-top-4": contentOnTop && gapOnTop === "4",
            "usbobp-layout--gap-on-top-8": contentOnTop && gapOnTop === "8",
            "usbobp-layout--gap-on-top-16": contentOnTop && gapOnTop === "16",
            "usbobp-layout--gap-on-top-24": contentOnTop && gapOnTop === "24",
            "usbobp-layout--gap-on-bottom-0":
              contentOnTop && gapOnBottom === "0",
            "usbobp-layout--gap-on-bottom-4":
              contentOnTop && gapOnBottom === "4",
            "usbobp-layout--gap-on-bottom-8":
              contentOnTop && gapOnBottom === "8",
            "usbobp-layout--gap-on-bottom-16":
              contentOnTop && gapOnBottom === "16",
            "usbobp-layout--gap-on-bottom-24":
              contentOnTop && gapOnBottom === "24",
            "usbobp-layout--gap-on-top-40": contentOnTop && actAsPageHeader,
            "usbobp-layout--gap-on-top-40-thru-margin": contentOnTop && actAsPageHeader && gapThruMarginTop
          })}
        >
          <USBColumn
            layoutOpts={{
              spans: {
                xlarge: compact ? 10 : 8,
                large: compact ? 10 : 8,
                medium: compact ? 8 : 6,
                small: 4,
              },
              offset: {
                xlarge: compact ? 3 : 4,
                large: compact ? 3 : 4,
                medium: compact ? 0 : 1,
              },
            }}
          >
            {contentOnTop}
          </USBColumn>
        </USBGrid>
      )}
      {getChildren(
        actAsPageHeader,
        actAsPageFooter,
        actAsCardFirstChildd,
        actAsCardLastChild,
        actAsCardLastChildFooter,
        actAsCardMiddleChild,
        removeBottomSpace,
        actAsCardChild,
        actAsShell,
        actAsShellChild,
        showThinBottomMargin,
        gapThruMarginOnly,
        showBottomDivider,
        isOnlyCardChild,
        mobileTopMargin,
        mobileBottomMargin,
        desktopTopLeftMargin,
        cardColorTheme,
        contentOnTop,
        gapOnTop,
        gapOnBottom,
        id,
        compact,
        otherProps,
        contentDirection,
        removeSpaceOf,
        children,
        isCardWithChildren,
        isMultiColumn,
        isMultiGrid,
        isCardListChild,
        hasGridZeroPadding,
        mobileZeroBottomMarginFirstChild,
        removeOlbTopPadding,
        cardInternalPadding,
        gapThruMarginTop
      )}
    </>
  );
};
export default BlockLayout;

BlockLayout.propTypes = {
  children: PropTypes.node.isRequired,
  contentOnTop: PropTypes.node,
  otherProps: PropTypes.any,
  compact: PropTypes.bool,
  showMobileBackground: PropTypes.bool,
  id: PropTypes.string,
  removeInMobileBP: PropTypes.bool,
  removeBottomSpace: PropTypes.bool,
  actAs: PropTypes.oneOf([
    "None",
    "PageHeader",
    "PageFooter",
    "CardFirstChild",
    "CardLastChild",
    "CardMiddleChild",
    "CardChild",
    "Shell",
    "ShellChild",
    "SrOnly",
    "Ghost",
  ]),
  contentDirection: PropTypes.oneOf(["column", "row"]),
  removeSpaceOf: PropTypes.arrayOf(PropTypes.string),
  mobileTopMargin: PropTypes.oneOf(["8", "10", "16", "24"]),
  desktopTopLeftMargin: PropTypes.oneOf(["16", "24"]),
  cardColorTheme: PropTypes.oneOf(["white", "gray"]),
  contentTopTheme: PropTypes.oneOf(["white", "gray"]),
  gapOnTop: PropTypes.oneOf(["0", "4", "8", "16", "24"]),
  gapOnBottom: PropTypes.oneOf(["0", "4", "8", "16", "24", "36", "40"]),
  isCardWithChildren: PropTypes.bool,
  isCardListChild: PropTypes.bool,
  mobileZeroBottomMarginFirstChild: PropTypes.bool,
  removeOlbTopPadding: PropTypes.bool,
  cardInternalPadding: PropTypes.oneOf(["16", "24"])
};
BlockLayout.defaultProps = {
  otherProps: {},
  showMobileBackground: false,
  id: "",
  removeInMobileBP: false,
  contentDirection: "column",
  removeBottomSpace: false,
  removeSpaceOf: [],
  mobileTopMargin: "16",
  desktopTopLeftMargin: "24",
  // gapOnTop: "0",
  // gapOnBottom: "0",
  cardColorTheme: "white",
  contentTopTheme: "gray",
  contentOnTop: null,
  isCardWithChildren: false,
  isCardListChild: false,
  mobileZeroBottomMarginFirstChild: false,
  removeOlbTopPadding:false,
  cardInternalPadding:"24"
};
function getChildren(
  actAsPageHeader: boolean,
  actAsPageFooter: boolean,
  actAsCardFirstChildd: boolean,
  actAsCardLastChild: boolean,
  actAsCardLastChildFooter: boolean,
  actAsCardMiddleChild: boolean,
  removeBottomSpace: any,
  actAsCardChild: boolean,
  actAsShell: boolean,
  actAsShellChild: boolean,
  showThinBottomMargin: any,
  gapThruMarginOnly: any,
  showBottomDivider: any,
  isOnlyCardChild: any,
  mobileTopMargin: any,
  mobileBottomMargin: any,
  desktopTopLeftMargin: any,
  cardColorTheme: any = "gray",
  contentOnTop: any,
  gapOnTop: any,
  gapOnBottom: any,
  id: any,
  compact: any,
  otherProps: any,
  contentDirection: any,
  removeSpaceOf: any,
  children: any,
  isCardWithChildren: boolean,
  isMultiColumn: boolean,
  isMultiGrid: boolean,
  isCardListChild: boolean,
  hasGridZeroPadding: boolean,
  mobileZeroBottomMarginFirstChild: boolean,
  removeOlbTopPadding: boolean,
  cardInternalPadding: string,
  gapThruMarginTop: boolean
) {
  // const childrenCheck = Children.only(children)
  if (!isCardWithChildren) {
    return (
      <USBGrid
        addClasses={classNames(
          ...[
            "usbobp-layout--override-row-gap",
            "usbobp-layout--override-tb-padding",
          ]
        )}
        addContainerClasses={classNames({
          "usbobp-layout--page-header": actAsPageHeader && !contentOnTop,
          "usbobp-layout--page-header-with-margin": actAsPageHeader && !contentOnTop && gapThruMarginTop,
          "usbobp-layout--page-footer": actAsPageFooter,
          "usbobp-layout--page-header-content-top":
            actAsPageHeader && contentOnTop,
          "usbobp-layout--card-first-child": actAsCardFirstChildd,
          "usbobp-layout--card-first-child--zero-margin":
            mobileZeroBottomMarginFirstChild,
          "usbobp-layout--card-last-child": actAsCardLastChild,
          "usbobp-layout--card-last-child footer-child": actAsCardLastChildFooter,
          "usbobp-layout--card-middle-child": actAsCardMiddleChild,
          "usbobp-layout--card-list-child": isCardListChild,
          "usbobp-layout--remove-bottom-space": removeBottomSpace,
          "usbobp-layout--card-child": actAsCardChild,
          "usbobp-layout--shell": actAsShell,
          "usbobp-layout--shell-child": actAsShellChild,
          "usbobp-layout--thin-margin": showThinBottomMargin,
          "usbobp-layout--bottom-divider": showBottomDivider,
          "usbobp-layout--card-only-child": isOnlyCardChild,
          "usbobp-layout--mobile-top-margin": mobileTopMargin,
          "usbobp-layout--mobile-bottom-margin": mobileBottomMargin,
          // "usbobp-layout--desktop-topLeft-margin": desktopTopLeftMargin,
          "usbobp-layout--desktop-topLeft-margin-16":
            desktopTopLeftMargin === "16",
          "usbobp-layout--mobile-top-margin-24": mobileTopMargin === "24",
          "usbobp-layout--mobile-top-margin-10": mobileTopMargin === "10",
          "usbobp-layout--mobile-top-margin-8": mobileTopMargin === "8",
          "usbobp-layout--mobile-top-margin-0": mobileTopMargin === "0",
          "usbobp-layout--mobile-bottom-margin-24": mobileBottomMargin === "24",
          "usbobp-layout--mobile-bottom-margin-10": mobileBottomMargin === "10",
          "usbobp-layout--mobile-bottom-margin-8": mobileBottomMargin === "8",
          "usbobp-layout--mobile-bottom-margin-0": mobileBottomMargin === "0",
          // "usbobp-layout--color-theme-white": cardColorTheme === "white",
          "usbobp-layout--color-theme-gray": cardColorTheme === "gray",
          "usbobp-layout--gap-on-top-0": !contentOnTop && gapOnTop === "0",
          "usbobp-layout--gap-on-top-4": !contentOnTop && gapOnTop === "4",
          "usbobp-layout--gap-on-top-8": !contentOnTop && gapOnTop === "8",
          "usbobp-layout--gap-on-top-16": !contentOnTop && gapOnTop === "16",
          "usbobp-layout--gap-on-top-24": !contentOnTop && gapOnTop === "24",
          "usbobp-layout--gap-on-bottom-0":
            !contentOnTop && gapOnBottom === "0",
          "usbobp-layout--gap-on-bottom-4":
            !contentOnTop && gapOnBottom === "4",
          "usbobp-layout--gap-on-bottom-8":
            !contentOnTop && gapOnBottom === "8",
          "usbobp-layout--gap-on-bottom-16":
            !contentOnTop && gapOnBottom === "16",
          "usbobp-layout--gap-on-bottom-24":
            !contentOnTop && gapOnBottom === "24",
          "usbobp-layout--gap-on-bottom-36":
            !contentOnTop && gapOnBottom === "36",
          "usbobp-layout--gap-on-bottom-40":
            !contentOnTop && gapOnBottom === "40",
          "usbobp-layout--remove-olb-top-padding":removeOlbTopPadding,
          "usbobp-layout--gap-thru-margin": gapThruMarginOnly,
          "usbobp-layout--internal-padding-16": cardInternalPadding === "16"
        })}
        addId={id}
        gridGap="normal"
        padding={hasGridZeroPadding ? "zero" : "normal"}
      >
        <USBColumn
          layoutOpts={{
            spans: {
              xlarge: compact ? 10 : 8,
              large: compact ? 10 : 8,
              medium: compact ? 8 : 6,
              small: 4,
            },
            offset: {
              xlarge: compact ? 3 : 4,
              large: compact ? 3 : 4,
              medium: compact ? 0 : 1,
            },
          }}
          {...otherProps}
        >
          <div
            className={classNames("usbobp-layout--children", {
              "usbobp-layout--children-dir-column":
                contentDirection === "column",
              "usbobp-layout--children-rm-padding":
                removeSpaceOf?.includes("padding"),
              "usbobp-layout--children-rm-margin":
                removeSpaceOf?.includes("margin"),
            })}
          >
            {children}
          </div>
        </USBColumn>
      </USBGrid>
    );
  } else if (isCardWithChildren) {
    return (
      <ShellGridColumn
        {...{
          isMultiColumn,
          isMultiGrid,
          actAsPageHeader,
          contentOnTop,
          actAsPageFooter,
          actAsCardFirstChildd,
          actAsCardLastChild,
          actAsCardLastChildFooter,
          actAsCardMiddleChild,
          removeBottomSpace,
          actAsCardChild,
          actAsShell,
          actAsShellChild,
          showThinBottomMargin,
          gapThruMarginOnly,
          showBottomDivider,
          isOnlyCardChild,
          mobileTopMargin,
          mobileBottomMargin,
          desktopTopLeftMargin,
          cardColorTheme,
          gapOnTop,
          gapOnBottom,
          id,
          compact,
          otherProps,
          contentDirection,
          removeSpaceOf,
          children,
          isCardListChild,
          hasGridZeroPadding,
          mobileZeroBottomMarginFirstChild,
          removeOlbTopPadding,
          cardInternalPadding
        }}
      />
    );
  } else {
    throw new Error(
      "If children has multiple elements do not pass inside fragment, else pass as a single node or element"
    );
  }
}
